import React, { useContext } from 'react';

import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/CloseRounded';
import { navigate } from '@reach/router';
import moment from 'moment';

import { GlobalContext } from '../../../../../store';

import { redWaglLogo } from '../../../../../assets/images/';
import addNewClubIcon from '../../../../../assets/images/menu_icons/add_new_club.png';
import adminDashboardIcon from '../../../../../assets/images/menu_icons/goto_admin.png';
import homeIcon from '../../../../../assets/images/menu_icons/my_clubhouse.png';
import loginIcon from '../../../../../assets/images/player-red.svg';
import Button from '../../../../Button';
import ClubLogo from '../../../../ClubLogo';

interface IProps {
  clubId: number;
  onClose: () => void;
  open: boolean;
}

const dateFormat = 'YYYY-MM-DD';

export const PlayerSideMenu = (props: IProps) => {
  const {
    actions: {
      auth: { logout: logoutAction }
    },
    clubs,
    events,
    user
  } = useContext(GlobalContext);

  const { open, onClose } = props;

  const liveEvent =
    events &&
    events.all &&
    Object.values(events.all).find(e =>
      e.rounds.find(r => moment(r.start).format(dateFormat) === moment().format(dateFormat))
    );

  const goLive = () => !!liveEvent && navigate(`/event/${liveEvent.id}`);

  const logout = async () => {
    await logoutAction();

    navigate('/login');

    onClose();
  };

  const goTo = (destination: string) => () => {
    navigate(destination);
    onClose();
  };

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <div className="menu-content">
        <div className="menu-header">
          <img src={redWaglLogo} className="logo" alt="logo" />

          <Button color="primary" className="menu-close" id="menu-close" onClick={onClose}>
            <CloseIcon />
          </Button>
        </div>
        <div className="menu-body">
          {!!liveEvent && (
            <Button
              variant="contained"
              className="button button--shadow live-link"
              color="primary"
              onClick={goLive}
            >
              GO TO LIVE EVENT
            </Button>
          )}

          <MenuItem
            button={true}
            component="a"
            onClick={goTo(`/staff/home`)}
            className="menu-item go-to-dashboard withBottomBorder"
          >
            <ClubLogo src={adminDashboardIcon} bordered={false} borderRadius="circle" />
            <span className="menu-text">GO TO ADMIN DASHBOARD</span>
          </MenuItem>

          {user.id !== 0 ? (
            <>
              <MenuItem button={true} component="a" onClick={goTo(`/home`)} className="menu-item">
                <ClubLogo src={homeIcon} bordered={true} borderRadius="circle" />
                <span className="menu-text">My Clubhouse</span>
              </MenuItem>

              <div className="withBottomBorder">
                {Object.values(clubs.all).map(club => (
                  <MenuItem
                    button={true}
                    key={`club-link-${club.id}`}
                    component="a"
                    onClick={goTo(`/club/${club.id}`)}
                    className="menu-item"
                  >
                    <ClubLogo src={club.profileImage || ''} bordered={true} borderRadius="circle" />
                    <span className="menu-text">{club.name}</span>
                  </MenuItem>
                ))}
              </div>

              {/* Disabled temporarily  */}
              {false && (
                <MenuItem
                  className="menu-item withBottomBorder start-new-club"
                  button={true}
                  component="a"
                  onClick={goTo('/staff/club/create/info')}
                >
                  <ClubLogo src={addNewClubIcon} className="logout no-shadow" />
                  <span className="menu-text">START A NEW CLUB</span>
                </MenuItem>
              )}

              {/* Disabled temporarily  */}
              {false && (
                <MenuItem
                  className="menu-item actions"
                  button={true}
                  component="a"
                  onClick={goTo('/b')}
                >
                  <span className="menu-text">Help</span>
                </MenuItem>
              )}

              <MenuItem className="menu-item actions" button={true} component="a" onClick={logout}>
                <span className="menu-text">Logout</span>
              </MenuItem>
            </>
          ) : (
            <MenuItem button={true} component="a" onClick={goTo('/login')} className="menu-item">
              <ClubLogo src={loginIcon} bordered={true} borderRadius="circle" />
              <span className="menu-text">LOGIN</span>
            </MenuItem>
          )}
        </div>
      </div>
    </Drawer>
  );
};
